import power from './power'

export default power
